/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TCreateHomeownerMessageFromOfferModel,
  ICreateHomeownerMessageFromOfferRequest,
  IMappers,
  ICreateHomeownerMessageFromOfferResponse,
  ICreateHomeownerMessageFromOfferResponseError,
  TCreateHomeownerMessageFromOfferResponse,
} from './types';

const defaultConfig: TCreateHomeownerMessageFromOfferModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  method: 'POST',
  microserviceName: 'demand',
  pathApi: '/v2/create-homeowner-message-from-offer/',
  hostType: 'api',
} as TCreateHomeownerMessageFromOfferModel;

function createCreateHomeownerMessageFromOfferModel(
  parameters: ICreateHomeownerMessageFromOfferRequest,
): TCreateHomeownerMessageFromOfferModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface ICreateHomeownerMessageFromOfferOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  parameters: ICreateHomeownerMessageFromOfferRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
}

async function fetchCreateHomeownerMessageFromOffer<TResponse200, TResponse400>({
  httpApi,
  parameters,
  config,
  mappers,
}: ICreateHomeownerMessageFromOfferOptions<TResponse200, TResponse400>): Promise<
  TResponse200 | TResponse400 | TCreateHomeownerMessageFromOfferResponse
> {
  const { response, statusCode } = await httpApi.fetch(createCreateHomeownerMessageFromOfferModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as ICreateHomeownerMessageFromOfferResponse);
    }

    if (statusCode === 400) {
      return mappers[400](response as ICreateHomeownerMessageFromOfferResponseError);
    }
  }

  return { response, statusCode } as TCreateHomeownerMessageFromOfferResponse;
}

export { defaultConfig, createCreateHomeownerMessageFromOfferModel, fetchCreateHomeownerMessageFromOffer };
